import React from 'react';
import { Route, Switch } from 'react-router';

import { routes } from 'utils/routes';
import { AppRoutingShared } from 'containers/AppRouting/AppRoutingShared';
import { SignOutPage } from 'containers/SignOutPage';
import { HomePageComponent } from 'containers/homePage/homePageComponents';
import { ProdStackManager } from 'containers/ProdStackManager/ProdStackManager';

export const AppRoutingClient = () => {
  return (
    <Switch>
      <Route path={routes.registrationProdPattern()}>
        <ProdStackManager />
      </Route>

      <Route path={routes.signOutPattern()}>
        <SignOutPage />
      </Route>

      <Route path="/" exact>
        <HomePageComponent />
      </Route>

      <Route path="/">
        <AppRoutingShared />
      </Route>
    </Switch>
  );
};
